import React from 'react';
import classes from './HomepageBody.module.scss';

export default () => (
  <div className="container">
    <p className={classes.homeText}></p>

    {/* <div className={classes.boxesContainer}>
      <Card
        label="Gym & Classes"
        body="Gym with full range of high-quality gym equipment. Studio classes, cardio and bespoke Supersonic fitness classes."
      />
      <Card
        label="Relax"
        body="Yoga and meditation for mental and spiritual relaxation. Spa-standard changing facilities. Living plant walls."
      />
      <Card
        label="Recovery"
        body="State-of-the art recovery zone with infrared and ice recovery. Injury rehab and return - to - fitness support."
      />
      <Card
        label="Café"
        body="Visit the Supersonic Cafe serving quality fresh and organic vegan, vegetarian and meat meals, snacks and drinks. Non-members are welcome"
      />
    </div> */}
  </div>
);
